export interface ITemplateManagementEnvironment {
    readonly endpoint: string;
}

const environments: { [stage: string]: { [region: string]: ITemplateManagementEnvironment } } = {
    localdev: {
        'us-west-2': {
            endpoint: process.env.TEMPLATE_MANAGEMENT_APPSYNC_ENDPOINT_URL || 'https://tm.beta.accelerate.proserve.aws.dev/graphql',
        },
    },
    beta: {
        'us-west-2': {
            endpoint: 'https://tm.beta.accelerate.proserve.aws.dev/graphql',
        },
    },
    gamma: {
        'us-west-2': {
            endpoint: 'https://tm.gamma.accelerate.proserve.aws.dev/graphql',
        },
    },
    prod: {
        'us-west-2': {
            endpoint: 'https://tm.accelerate.amazonaws.com/graphql',
        },
    },
};

/**
 * Get information for interacting with Template Management in the given stage/region
 * @param stage - localdev, beta, gamma, or prod
 * @param region - only us-west-2 is currently in use
 * @returns {ITemplateManagementEnvironment} an environment object with the AppSync API endpoint
 */
export const getTemplateManagementEnvironment = (stage: 'localdev' | 'beta' | 'gamma' | 'prod', region: string): ITemplateManagementEnvironment => {
    if (environments[stage] && environments[stage][region]) {
        return environments[stage][region];
    } else {
        throw new Error(`Unable to find requested environment for ${stage} and ${region}`);
    }
};
